import CustomSegment from "@/components/CustomSegment";
import PageTitle from "@/components/PageTitle";
import { useSegment } from "@/hooks/useSegment";
import DashboardLayout from "@/layouts/DashboardLayout";
import type { SegmentedType } from "@/types/global.types";
import Filters from "./_components/Filters";
import Applicants from "./Applicants";
import JobPost from "./JobPost";
import Shortlisted from "./Shortlisted";
import TalentHunt from "./TalentHunt";

export type JobApplicantsSegmentType =
  | "job-post"
  | "applicants"
  | "talent-hunt"
  | "shortlisted";

const JobApplicants = () => {
  const { segment, setSegment } = useSegment<JobApplicantsSegmentType>(
    "recruitment-job-applicants",
    "job-post",
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<JobApplicantsSegmentType>[] = [
    {
      value: "job-post",
      label: "Job Post",
      view: <JobPost setSegment={setSegment} />,
    },
    {
      value: "applicants",
      label: "Applicants",
      view: <Applicants />,
    },
    {
      value: "talent-hunt",
      label: "TalentHunt",
      view: <TalentHunt />,
    },
    {
      value: "shortlisted",
      label: "Shortlisted",
      view: <Shortlisted />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Job & Applicants">
      <PageTitle
        classNames={{ root: "items-start" }}
        title="Jobs"
        items={[
          { title: "Dashboard", path: "/admin/recruitment/dashboard" },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default JobApplicants;
